import { Component, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MAX_MATCH_JOKERS } from '../../constants/joker.constants';
import { SidenavService } from '../../services/sidenav.service';

@Component({
  selector: 'app-rules',
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.scss'],
  standalone: false,
})
export class RulesComponent implements OnInit {
  sidenav: MatSidenav;
  readonly maxMatchJokers = MAX_MATCH_JOKERS;

  constructor(private sidenavService: SidenavService) {
    this.sidenav = this.sidenavService.getSidenav();
  }

  ngOnInit(): void {}

  toggleMenu() {
    this.sidenavService.toggle();
  }

  scrollToSection(sectionId: string, event: Event) {
    event.preventDefault();

    const section = document.getElementById(sectionId);
    if (!section) {
      return;
    }

    section.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
}
